import { apiSlice } from '../../../api/apiSlice';
import { PAY_QUALIFIERS } from '../../../constants';

export const payRulesQualifiersSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getPayQualifiers: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month, scorecardVersionId } = arg;
                return {
                    url: PAY_QUALIFIERS,
                    params: { employeeNumber, year, month, scorecardVersionId },
                };
            },
        }),
        
    }),
});

export const {
    useGetPayQualifiersQuery
} = payRulesQualifiersSlice;
